import { Grid } from "@mui/material";
import React from "react";
import * as yup from "yup";
import { ControlText } from "../../helpers";
import { ControlSelect2 } from "../../helpers/ControlSelect2";
import { ControlSmallWrapper } from "../../helpers/ControlSmallWrapper";
import { AbmForm } from "../AbmForm";

const schema = yup.object().shape({});

export const FormParticipante = React.forwardRef(({
  item,
  onConfirm,
  onCancel,
  data = {}
}, ref) => {
  return (
    <AbmForm
      ref={ref}
      actionsBottom={false}
      onSubmit={onConfirm}
      schema={schema}
      item={item}
      onCancel={onCancel}
    >
      {({onControlChange, entity, entityErrors}) => (
        <>
          <Grid item xs={12}>
            <ControlSelect2
              name="id_categoria"
              label="Categoría"
              errors={entityErrors}
              data={entity}
              onChange={onControlChange}
              options={data?.categorias || []}
              isMulti={false}
              closeMenuOnSelect={true}
              Wrapper={ControlSmallWrapper}
            />
          </Grid>

          <Grid item xs={12}>
            <ControlSelect2
              name="id_genero"
              label="Género"
              errors={entityErrors}
              data={entity}
              onChange={onControlChange}
              options={data?.generos || []}
              isMulti={false}
              closeMenuOnSelect={true}
              Wrapper={ControlSmallWrapper}
            />
          </Grid>

          <Grid item xs={12}>
            <ControlSelect2
              name="id_origen"
              label="Origen"
              errors={entityErrors}
              data={entity}
              onChange={onControlChange}
              options={data?.origenes || []}
              isMulti={false}
              closeMenuOnSelect={true}
              Wrapper={ControlSmallWrapper}
            />
          </Grid>

          <Grid item xs={12}>
            <ControlText
              name="cantidad"
              label="Cantidad"
              type="number"
              errors={entityErrors}
              data={entity}
              onChange={onControlChange}
              Wrapper={ControlSmallWrapper}
              errorPlacement="bottom"
            />
          </Grid>
        </>
      )}
    </AbmForm>
  );
});
